import { z } from "zod";

import { api } from "~/api";
import { createServiceResponseSchema } from "../schemas";
import { referralSourceSchema } from "./schemas";

export const getReferralSourcesList = async () => {
  const response = await api.get("referral-sources");
  return createServiceResponseSchema(z.array(referralSourceSchema)).parse(
    response.data,
  ).data;
};
